import './pdfWorker';

export const getPdfText = async (pdfData: string | null) => {
  if (!pdfData) return;

  try {
    const pdfjsLib = await import("pdfjs-dist");
    const pdf = await pdfjsLib.getDocument(pdfData).promise;
    const numPages = pdf.numPages;
    let plainText = "";

    for (let pageNum = 1; pageNum <= numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const textContent = await page.getTextContent();
      plainText += textContent.items.map((item) => (item as { str: string }).str).join(" ") + " ";
    }

    return plainText.trim();
  } catch (error) {
    console.error("Error extracting PDF text:", error);
  }
};

export const getPdfImages = async (file: File | null) => {
  if (!file) return;

  const pdfData = URL.createObjectURL(file);

  const pdfjsLib = await import("pdfjs-dist");

  try {
    const pdf = await pdfjsLib.getDocument(pdfData).promise;
    const numPages = pdf.numPages;
    const imagePromises: Promise<File>[] = [];

    for (let pageNum = 1; pageNum <= numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const viewport = page.getViewport({ scale: 3 });
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      if (!context) continue;
      await page.render({ canvasContext: context, viewport }).promise;

      // Create a promise for each toBlob operation
      const imagePromise = new Promise<File>((resolve) => {
        canvas.toBlob((blob) => {
          const imageFile = new File(
            [blob!],
            `${file.name.replace(".pdf", "")}_page_${pageNum}.png`,
            {
              type: "image/png",
            }
          );
          resolve(imageFile);
        });
      });

      imagePromises.push(imagePromise);
    }

    // Wait for all image promises to resolve
    const images = await Promise.all(imagePromises);
    return images;
  } catch (error) {
    console.error("Error extracting PDF images:", error);
    return [];
  }
};
